import React from 'react';

interface Props {
  loaded: number;
  total: number;
  hasMore: boolean;
  isLoading: boolean;
  onLoadMore: () => void;
  sentinelRef?: React.Ref<HTMLDivElement>;
}

export function LoadMoreFooter({ loaded, total, hasMore, isLoading, onLoadMore, sentinelRef }: Props) {
  return (
    <div className="mt-4 flex flex-col items-center gap-3">
      <span className="text-xs text-gray-500 dark:text-gray-400">
        Showing {loaded.toLocaleString()} of {total.toLocaleString()}
      </span>
      {hasMore && (
        <button
          type="button"
          className="btn-secondary text-sm disabled:opacity-50"
          onClick={onLoadMore}
          disabled={isLoading}
        >
          {isLoading ? 'Loading…' : 'Load more'}
        </button>
      )}
      {/* Sentinel for auto infinite-scroll; harmless when hasMore is false */}
      <div ref={sentinelRef} aria-hidden className="h-px w-full" />
    </div>
  );
}
